import React, { useState, useEffect } from 'react';
import ActivityImg from './images/Incubating.png';
import ClassImg from './images/WorkForce.png'
import AntClasses from './AntClasses'
import ConfirmAntfoodSpend from './ConfirmAntfoodSpend';
import useSolanaWeb3 from '../hooks/useSolanaWeb3.js';
import premiumAnt from './images/ANT.png';

function Incubating({ changeActiveComponent }) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [premiumBatchInfo, setPremiumBatchInfo] = useState({ maxSupply: 0, minted: 0 });

  const { fetchPremiumBatchInfo } = useSolanaWeb3();

  useEffect(() => {
    const getPremiumBatchInfo = async () => {
      const info = await fetchPremiumBatchInfo();
      setPremiumBatchInfo(info);
    };

    getPremiumBatchInfo();
  }, [fetchPremiumBatchInfo]);

  const remainingSupply = premiumBatchInfo.maxSupply - premiumBatchInfo.minted;

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  return (
    <section id="nestwars">
      <div className="newui-container">
      <div className="platform-container">
      <div className="inventory-container">
        <div className="inventory-container-left" id="incubating">
          <div className="incubating-class-active"><h2>ACTIVE ANT CLASS</h2><button className="incubating-button" onClick={() => handleItemClick('antclasses')}>ANT CLASSES</button></div>
          <div className="incubating-left">
            <div className="incubating-left-container">
              <img src={ClassImg}></img><h3>Premium</h3><h2>WORKER ANT</h2><p>LVL: 20</p>
            </div></div>
            <div className="incubating-center"><img src={premiumAnt}></img></div>
          <div className="incubating-right">
            <div className="incubating-right-container"><h3>Supply Left</h3><h2>{remainingSupply} NFTs</h2></div>
            <div className="incubating-right-container"><h3>Total Supply</h3><h2>{premiumBatchInfo.maxSupply} NFTs</h2></div>
            <div className="incubating-right-container"><h3>Required $ANTF</h3><h2>{900} $ANTF</h2></div>
          </div>
          <button className="provide-button" onClick={() => handleItemClick('confirmantfoodspend')}>PROVIDE $ANTF</button>
        </div>
        <div className="inventory-container-right">
        <div className="left-content-incubating">
            <img src={ActivityImg}></img>
            <h1>INCUBATING</h1>
            <p>Provide food for the Kingdom in exchange of Premium ANT! Premium ANTS starts from level 20.</p>
        </div>
      </div>
      {selectedItem === 'antclasses' && <AntClasses onClose={() => setSelectedItem(null)} />}
      {selectedItem === 'confirmantfoodspend' && <ConfirmAntfoodSpend antFoodFee={900} onClose={() => setSelectedItem(null)} />}
    </div>
    </div>
    </div>
    </section>
  );
}

export default Incubating;